import type { RouteRecordRaw } from "vue-router";

export const feedbackRoutes: RouteRecordRaw[] = [
  // AI Feedbacks
  // Static routes before dynamic :id
  {
    path: "/ai/feedbacks",
    name: "feedback-index",
    component: () => import("./feedbacks/AiFeedbackListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "ai_feedback",
      title: "tools_meta.ai_feedbacks_prefix",
    },
  },
  {
    path: "/ai/feedbacks/info",
    name: "ai_feedback-info",
    component: () => import("./feedbacks/info.vue"),
    meta: {
      namespace: "ai_feedback",
      title: "tools_meta.ai_feedbacks_prefix",
    },
  },
  {
    path: "/ai/feedbacks/:id",
    name: "feedback-show",
    component: () => import("./feedbacks/[id]/AiFeedbackDetailPage.vue"),
    meta: {
      namespace: "ai_feedback",
      title: "tools_meta.ai_feedbacks_prefix",
    },
  },
  {
    path: "/ai/feedbacks/:id/results",
    name: "feedback-result-index",
    component: () =>
      import("./feedbacks/[id]/results/AiFeedbackResultListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "ai_feedback",
      title: "tools_meta.ai_feedbacks_prefix",
    },
  },
  {
    path: "/ai/feedbacks/:id/results/:feedbackResultPage()_:feedbackId?",
    name: "feedback-result-show",
    component: () =>
      import("./feedbacks/[id]/results/[feedbackResultPage]_[[feedbackId]]/AiFeedbackResultDetailPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "ai_feedback",
      title: "tools_meta.ai_feedbacks_prefix",
    },
  },
];
